import { DecimalPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'cyc-progress-bar',
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe],
  host: {
    class: 'cyc-progress-bar',
    '[class.cyc-progress-bar--max-width]': 'maxWidth()',
    '[class.cyc-progress-bar--responsive]': 'responsive()',
    '[class.cyc-progress-bar--footer-style]': 'footerStyle()',
  },
})
export class ProgressBarComponent {
  value = input<number>()
  responsive = input(false)
  maxWidth = input(true)
  showPercentage = input(true)
  footerStyle = input(false)
}
